import { get } from "svelte/store";
import { usersStore } from "../../../api-stores/user-store";
import { diallerState } from "./diallerState.svelte";
import { getUserNameFromId } from "./stores";

export class AttendeesState {
  user = $state(null);
  userData = $derived(get(usersStore) || []);
  candidate = $state(null);
  manager = $state(null);
  teammate = $state(null);
  currentUserType = $state(null); // "user" | "manager" | "teammate"

  get attendees() {
    const attendees = [this.user, this.candidate, this.manager, this.teammate];
    return attendees.filter((attendee) => !!attendee);
  }

  set attendees(attendees) {
    ["user", "candidate", "manager", "teammate"].forEach((role) => {
      this[role] = attendees.find((a) => a.role === role) || null;
    });

    // Update conference call state based on attendee count
    if (this.attendees.length === 2 && this.currentUserType === "user") {
      diallerState.isConferenceCall = false;
      diallerState.ableToAddTeammate = true;
    }
  }

  getRoleFromMode = (mode) => {
    if (["listen", "coach", "participate"].includes(mode)) return "manager";
    else if (mode === "client") return "user";
    return mode;
  };

  convertCallToAttendees = (call) => {
    const users = Object.entries(call.attendees)
      .filter(
        ([callLegId, value]) => !value.leftAt && callLegId !== call.callId,
      )
      .map(([id, value]) => {
        const [mode, userId] = value.label?.split(":") || [];
        const name = userId ? getUserNameFromId(userId, this.userData) : null;
        const role = this.getRoleFromMode(mode);

        const ret = {
          id,
          ...value,
          name,
          userId,
          role,
        };
        if (role === "teammate") ret.inviteStatus = "accepted";
        if (role === "manager") ret.mode = mode;

        return ret;
      })
      .filter((attendee) => !attendee.leftAt);

    const candidate = {
      ...this.candidate,
      role: "candidate",
    };

    this.attendees = [candidate, ...users];
  };

  reset() {
    this.user = null;
    this.candidate = null;
    this.manager = null;
    this.teammate = null;
    this.attendees = [];
  }
}

export const attendeesState = new AttendeesState();
